/**
 * @param {string} uniqueId
 * @param {string} title
 * @param {string} companyName
 * @param {Array<string>} locations
 * @param {string} jobType
 * @param {string} stationName
 * @param {string} salary
 * @param {Object} featureViewModel
 * @param {Object|null} contentViewModel
 * @param {string|null} sourceName
 * @param {Array<object>} trainList
 * @param {boolean} isDisplayCompanyName
 * @param {boolean} isDisplayLocation
 * @param {boolean} isDisplayJobType
 * @param {boolean} isDisplayStation
 * @param {boolean} isDisplaySalary
 * @param {boolean} isDisplayFeatures
 * @param {string} redirectUrl
 * @param {string} jobcubeDetailUrl
 * @param {boolean} fromSearchResult
 * @param {boolean} isValid
 * @param {Object|null} analyticsViewModel
 * @param {string} companyNameExistence
 * @constructor
 */
export function JobDetailData({
    uniqueId,
    title,
    companyName,
    locations,
    jobType,
    stationName,
    salary,
    featureViewModel,
    contentViewModel,
    sourceName,
    trainList,
    isDisplayCompanyName,
    isDisplayLocation,
    isDisplayJobType,
    isDisplayStation,
    isDisplaySalary,
    isDisplayFeatures,
    redirectUrl,
    jobcubeDetailUrl,
    fromSearchResult,
    isValid,
    analyticsViewModel,
    companyNameExistence
}) {
    this.uniqueId = uniqueId;
    this.title = title;
    this.companyName = companyName;
    this.locations = locations;
    this.jobType = jobType;
    this.stationName = stationName;
    this.salary = salary;
    this.featureViewModel =  featureViewModel;
    this.upperPanelSectionViewModel = contentViewModel?.upperPanelSectionViewModel;
    this.tableSectionViewModel = contentViewModel?.tableSectionViewModel;
    this.bottomSectionViewModel = contentViewModel?.bottomSectionViewModel;
    this.sourceName = sourceName;
    this.trainList = trainList;
    this.isDisplayCompanyName = isDisplayCompanyName;
    this.isDisplayLocation = isDisplayLocation;
    this.isDisplayJobType = isDisplayJobType;
    this.isDisplayStation = isDisplayStation;
    this.isDisplaySalary = isDisplaySalary;
    this.isDisplayFeatures = isDisplayFeatures;
    this.redirectUrl = redirectUrl;
    this.jobcubeDetailUrl = jobcubeDetailUrl;
    this.fromSearchResult = fromSearchResult;
    this.isValid = isValid;
    this.analyticsViewModel = {
        channelName: analyticsViewModel?.channelName,
        isIndex: analyticsViewModel?.isIndex,
        uniqueId: analyticsViewModel?.uniqueId,
        sourceName: analyticsViewModel?.sourceName,
        jobTypes: analyticsViewModel?.jobTypes,
        salary: analyticsViewModel?.salary,
        location: analyticsViewModel?.location,
        type: analyticsViewModel?.type,
        maskedCost: analyticsViewModel?.maskedCost,
        convertedAndMaskedCost: analyticsViewModel?.convertedAndMaskedCost,
        companyNameExistence: companyNameExistence,
        companyName: companyName,
        title: title,
        salaryValue: salary,
    };
}
